import { createSlice } from '@reduxjs/toolkit';
import { fetchAllNoticesByAdmin } from '../actions/noticeActions';

const initialState = {
  notices: [],
  loading: false,
  error: null,
  meta: null
};

const noticeSlice = createSlice({
  name: 'notice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllNoticesByAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllNoticesByAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.notices = action.payload.data || [];
        state.meta = action.payload.meta || null;
      })
      .addCase(fetchAllNoticesByAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch notices';
      });
  }
});

export default noticeSlice.reducer;
